import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const readApiError = (error: unknown, fallback: string) => {
    if (typeof error === 'object' && error && 'response' in error) {
        const msg = (error as { response?: { data?: { msg?: string } } }).response?.data?.msg
        if (typeof msg === 'string' && msg) {
            return msg
        }
    }
    if (error instanceof Error && error.message) {
        return error.message
    }
    return fallback
}

const deleteAvitoProfile =
    (id: string) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        const params = {
            userId: userData.smsAuth.userId,
            id,
        }
        try {
            const {
                data: { status, data, msg },
            } = await apiInstance.post('/sales/marketplaces/deleteAvitoProfile', params, config)
            if (status === 'ok' && data) {
                dispatch({
                    type: storeDispatchTypes.setAvitoProfiles,
                    value: data,
                })
                return
            }
            throw new Error(msg || 'Не удалось удалить профиль')
        } catch (e) {
            const message = readApiError(e, 'Не удалось удалить профиль')
            console.error('delete avito profile failed', e)
            throw new Error(message)
        }
    }

export default deleteAvitoProfile
